<template>
  <div v-loading="loading" class="rj-page-card">
    <div v-if="!btnStatus" class="rj-page-card__title">
      待审批批次付款明细
    </div>
    <div v-if="btnStatus" class="rj-page-card__title">
      已确认批次付款明细
    </div>
    <div class="rj-page-card__content">
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              批次付款申请编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.batchApplyId }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              批次发货编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.batchDeliveryId }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              申请时间：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.applyTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              申请人：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.applicant }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              下单主体：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.businessEntity }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              客户名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.agentName }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              国家：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.overSeasSalesCountry }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              贸易术语：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.tradeTerms }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              批次请款总金额：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.batchDeliveryTotalAmount ? Number(info.batchDeliveryTotalAmount).toFixed(2) : '0.00' }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              付款方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.salesType }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              外销：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.salesManName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              部门：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.departmentName }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              币种：
            </div>
            <div class="rj-baseinfo__item">
              {{ info.currencyName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header" style="margin-top: 16px;">
      <el-button v-if="!btnStatus" type="primary" @click="exportProduct">导出明细</el-button>
      <el-button v-else type="primary" @click="exportProducts">导出明细</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top: 16px;"
      show-summary
      :summary-method="renderSummary"
    >
      <el-table-column type="index" label="序号" width="50px" align="left" fixed="left" />
      <el-table-column prop="contractNum" label="合同编号" />
      <el-table-column prop="projectName" label="项目名称" />
      <el-table-column prop="productSerialNo" label="料号" />
      <el-table-column prop="productName" label="产品型号" />
      <el-table-column prop="quantity" label="数量" />
      <el-table-column prop="unitPrice" label="单价" />
      <el-table-column prop="orderAmount" label="订单金额">
        <template v-slot="{ row }">
          {{ row.orderAmount ? Number(row.orderAmount).toFixed(2) : '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="amountSum" label="实际结算金额">
        <template v-slot="{ row }">
          {{ row.amountSum ? Number(row.amountSum).toFixed(2) : '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="salesType" label="付款方式" />
      <el-table-column prop="expectedDeliveryDate" label="期望发货日期" />
      <el-table-column prop="deliveryDateAfterRectification" label="整改后交期" />
      <el-table-column prop="hopeOrderTime" label="希望开单时间" />
      <el-table-column prop="accountPeriod" label="账期" />
      <el-table-column prop="categoryAllocatedRatio" label="订单分配比例" />
      <el-table-column v-if="btnStatus" prop="applyStatus" label="申请状态" />
      <el-table-column prop="cashPointRatio" label="原单现金点比例" />
      <el-table-column prop="rebateUsedAmount" label="原单整单使用返利金额" />
    </el-table>
    <div v-if="page.total > 100" style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[100]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>
    <div class="footer" style="text-align: center; margin-top: 20px;">
      <el-button
        v-if="!btnStatus"
        type="primary"
        :loading="approveLoading"
        :disabled="approveLoading"
        @click="approved"
      >
        通过
      </el-button>
      <el-button
        v-if="!btnStatus"
        :loading="rejectLoading"
        :disabled="rejectLoading"
        @click="reject"
      >
        驳回
      </el-button>
    </div>
    <ApprovedDialog ref="ApprovedDialogVisible" @approvedSubmit="approvedSubmit" />
    <ReasonRejectionDialog ref="ReasonDialogVisible" @handleReject="handleReject" />
  </div>
</template>
<script type="es6">
import ApprovedDialog from './ApprovedDialog.vue';
import { Message } from 'element-ui';
import ReasonRejectionDialog from './ReasonRejectionDialog.vue';
import { downloadBlobFile } from '@/libs/util';
import { GetIntelPaymentBatchApplyDetail,
  IntelPaymentBatchApplyHandle,
  ExportIntelPaymentBatchApplyDetail,
  GetIntelPaymentBatchApplyDetailList,
  ExportBatchPaymentDoneDetail } from '@/API/BatchManagement.js';
export default {
  components: {
    ApprovedDialog,
    ReasonRejectionDialog
  },
  data () {
    const { query = {}, params = {} } = this.$route || {};
    const batchApplyId = query.batchApplyId || params.batchApplyId || params.contractNum || '';
    return {
      loading: false,
      info: {
        ApplicationNumber: '示例项目名称'
      },
      ApprovedDialogVisible: false,
      tableData: [],
      btnStatus: this.$route.query.status,
      batchApplyId,
      page: {
        currentPage: 1,
        pageSize: 100,
        total: 0
      },
      approveLoading: false,
      rejectLoading: false
    };
  },
  methods: {
    approved () {
      if (this.approveLoading) {
        return;
      }
      this.$refs.ApprovedDialogVisible.openDialog();
    },
    reject () {
      if (this.rejectLoading) {
        return;
      }
      this.$refs.ReasonDialogVisible.openDialog();
    },
    renderSummary ({ columns, data }) {
      const totals = columns.map((column, index) => {
        if (index === 0) {
          return '总计';
        }
        if (column.property === 'orderAmount' || column.property === 'amountSum') {
          const total = data.reduce((acc, item) => acc + (Number(item[column.property]) || 0), 0);
          return total ? total.toFixed(2) : '0.00';
        }
        return '';
      });
      return totals;
    },
    async getInfo () {
      const res = await GetIntelPaymentBatchApplyDetail({ batchApplyId: this.batchApplyId });
      this.info = res.data.data;
    },
    async getList () {
      const params = {
        batchApplyId: this.batchApplyId,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.loading = true;
      try {
        const res = await GetIntelPaymentBatchApplyDetailList(params);
        const { list = [], total = 0 } = res.data.data || {};
        this.tableData = list;
        this.page.total = total;
      } catch (error) {
        this.tableData = [];
      } finally {
        this.loading = false;
      }
    },
    handerSizeChange (size) {
      this.page.pageSize = size;
      this.page.currentPage = 1;
      this.getList();
    },
    handerCurrentChange (page) {
      this.page.currentPage = page;
      this.getList();
    },
    approvedSubmit ({ done } = {}) {
      if (this.approveLoading) {
        return;
      }
      this.approveLoading = true;
      const finish = (success = false) => {
        this.approveLoading = false;
        if (typeof done === 'function') {
          done(success);
        }
      };
      IntelPaymentBatchApplyHandle({ batchApplyId: this.batchApplyId, approvalAction: 'process' }).then((res) => {
        if (res.data.status === '200') {
          Message.success(res.data.err);
          finish(true);
          this.$router.push({ path: '/OverseasBatchPaymentManagement', query: { tab: '2' } });
        } else {
          Message.error(res.data.err);
          finish(false);
        }
      }).catch(() => {
        Message.error('操作失败，请稍后重试');
        finish(false);
      });
    },
    handleReject ({ reason, done } = {}) {
      if (this.rejectLoading) {
        return;
      }
      const remark = typeof reason === 'string' ? reason : '';
      this.rejectLoading = true;
      const finish = (success = false) => {
        this.rejectLoading = false;
        if (typeof done === 'function') {
          done(success);
        }
      };
      IntelPaymentBatchApplyHandle({ batchApplyId: this.batchApplyId, approvalAction: 'reject', remark }).then((res) => {
        if (res.data.status === '200') {
          Message.success(res.data.err);
          finish(true);
          this.$router.push({ path: '/OverseasBatchPaymentManagement', query: { tab: '2' } });
        } else {
          Message.error(res.data.err);
          finish(false);
        }
      }).catch(() => {
        Message.error('操作失败，请稍后重试');
        finish(false);
      });
    },
    exportProduct () {
      const params = {
        batchApplyId: this.batchApplyId,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
        batchDeliveryId: this.info.batchDeliveryId,
        contractNum: this.info.contractNum,
        applicant: this.info.applicant,
        businessEntity: this.info.businessEntity,
        agentName: this.info.agentName
      };
      ExportIntelPaymentBatchApplyDetail(params).then((res) => {
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '批次付款明细'
        });
      });
    },
    exportProducts () {
      const params = {
        batchApplyId: this.batchApplyId,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
        batchDeliveryId: this.info.batchDeliveryId,
        contractNum: this.info.contractNum,
        applicant: this.info.applicant,
        businessEntity: this.info.businessEntity,
        agentName: this.info.agentName
      };
      ExportBatchPaymentDoneDetail(params).then((res) => {
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '批次付款明细'
        });
      });
    }
  },
  mounted () {
    this.getInfo();
    this.getList();
  }
};
</script>

<style scoped></style>
